import { decorate, observable, action } from 'mobx';

import { getAllFaqs } from '../../apis/six-api/v1/faqs';

export default class FaqStore {
  isLoading = false;

  data = {
    faqs: [],
  };

  getAllFaqs = async () => {
    try {
      this.isLoading = true;

      const {
        data: { records },
      } = await getAllFaqs();

      this.data.faqs = [...records];
    } catch (error) {
      this.data.faqs = [];
    } finally {
      this.isLoading = false;
    }
  };
}

decorate(FaqStore, {
  data: observable,
  isLoading: observable,
  getAllFaqs: action,
});

const faqStore = new FaqStore();

export { faqStore };
